/* accept variant, color */
import React from 'react';

import { Typography } from '@material-ui/core';
import type { Variant } from '@material-ui/core/styles/createTypography';

interface Props {
    children: React.ReactNode;
    color?: string;
    variant?: Variant;
    className?: string;
    style?: React.CSSProperties;
}

const InlineTypography: React.FC<Props> = ({ 
    children,
	color, 
    variant = 'body1',
    className, 
    style = {}
}) => {

    const textStyle = {
        ...style
    }
    if (color) {
        textStyle.color = color;
    }

	return <Typography 
        className={ className } style={ textStyle }
        variant={ variant } display="inline"
    >{ children }</Typography>

};

export default InlineTypography;
